import React from "react"
import Title from "../../atoms/Title"
import Clutch from "../../atoms/Clutch"
import "./styles.scss"
const ClutchCard = ({ review }) => {
  return (
    <div className="clutchCard">
      <Clutch rating={review.reviewRate} />
      <Title className="clutchCard__title" type="h3">
        {review.review}
      </Title>
      <Title type="h4" className="clutchCard__author">
        {review.reviewerName}
      </Title>
      <p className="clutchCard__profession">{review.reviewerJob}</p>
    </div>
  )
}

export default ClutchCard
